import { splitText } from './splitText';

export function mapParagraphs(text?: string) {
    if (text === undefined || text === null) {
        return [];
    }

    return splitText(text).map((paragraph, index) => (
        <p
            key={index}
            dangerouslySetInnerHTML={{
                __html: paragraph,
            }}
        />
    ));
}
